import toast from "react-hot-toast";

interface CopyTextParagraphProps {
  content: string;
  copyText: string;
  hint?: string;
}

export const CopyTextParagraph = ({content, copyText, hint}: CopyTextParagraphProps) => {
  const _copyToClipboard = (text = "") => {
    if (!text) return;
    navigator.clipboard.writeText(text);
    toast.success("Copied to clipboard!")
  };

  return hint ? (
    <p
      data-tooltip-id="tooltip"
      data-tooltip-content={hint}
      className="w-fit hover:cursor-pointer"
      onClick={() => _copyToClipboard(copyText)}
    >
      {content}
    </p>
  ) : (
    <p
      className="w-fit hover:cursor-pointer"
      onClick={() => _copyToClipboard(copyText)}
    >
      {content}
    </p>
  )
}